import graphql__fdc33a13d1137cd76548 from "./__generated__/UpdateNotificationSettingsMutation.graphql.js";import { commitMutation } from "react-relay";
import { graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

import serializeAnswers from "../helpers/serializeAnswers";

const mutation = graphql__fdc33a13d1137cd76548;

function updateNotificationSettings(form, onCompleted) {
  const variables = {
    notificationSettings: serializeAnswers(form)
  };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { updateNotificationSettings };
